(() => {
  'use strict';
  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const modal = root.querySelector('[data-vt-video-modal]');
    const player = root.querySelector('[data-vt-video-player]');
    const previews = root.querySelectorAll('[data-preview-url]');
    let lastOpener = null;

    const loadPreviews = () => {
      previews.forEach((preview) => {
        if (preview.dataset.previewLoaded === 'true') return;
        preview.dataset.previewLoaded = 'true';
        preview.preload = 'metadata';
        preview.src = preview.dataset.previewUrl;
        preview.load();
      });
    };

    if ('IntersectionObserver' in window) {
      const previewObserver = new IntersectionObserver((entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        loadPreviews();
      }, { rootMargin: '500px 0px' });
      previewObserver.observe(root);
    } else {
      loadPreviews();
    }

    // Keep the modal outside the product column's stacking context so sticky
    // product controls can never render above the video.
    const mountModalAtPageRoot = () => {
      if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);
    };
    const close = () => {
      if (!modal || !player) return;
      player.pause();
      player.removeAttribute('src');
      player.load();
      modal.hidden = true;
      document.body.classList.remove('vt-video-modal-open');
      if (lastOpener) lastOpener.focus({ preventScroll: true });
    };
    root.querySelectorAll('[data-vt-video-open]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!modal || !player) return;
        lastOpener = button;
        mountModalAtPageRoot();
        player.src = button.dataset.videoUrl || '';
        modal.hidden = false;
        document.body.classList.add('vt-video-modal-open');
        modal.querySelector('[data-vt-video-close]')?.focus({ preventScroll: true });
        player.play().catch(() => {});
      });
    });
    root.querySelectorAll('[data-vt-video-close]').forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) close();
    });
  };
  const boot = () => document.querySelectorAll('[data-vt-gallery-videos]').forEach(init);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState !== 'loading') boot();
})();
